var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCardLogoVisa = function SvgCardLogoVisa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 39,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54.88,
    height: 37.38,
    x: 0.56,
    y: 0.56,
    fill: "#F9F9FA",
    rx: 5.44
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 54.88,
    height: 37.38,
    x: 0.56,
    y: 0.56,
    stroke: "#DFE0E5",
    strokeWidth: 1.12,
    rx: 5.44
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#172B85",
    fillRule: "evenodd",
    d: "M17.706 25.44h-3.392l-2.544-9.73c-.12-.448-.377-.844-.754-1.03a11 11 0 0 0-3.11-1.03v-.375h5.465c.754 0 1.32.563 1.414 1.217l1.32 7.019 3.391-8.235h3.298zm6.974 0h-3.204l2.638-12.165h3.204zm6.783-8.795c.095-.655.66-1.03 1.32-1.03 1.037-.094 2.167.094 3.11.561l.566-2.62a8.1 8.1 0 0 0-2.922-.562c-3.11 0-5.372 1.685-5.372 4.024 0 1.779 1.603 2.713 2.734 3.276 1.224.56 1.696.936 1.601 1.497 0 .841-.942 1.216-1.884 1.216-1.131 0-2.262-.28-3.298-.75l-.566 2.621c1.132.468 2.356.656 3.487.656 3.487.092 5.654-1.591 5.654-4.118 0-3.182-4.43-3.368-4.43-4.771m15.643 8.796-2.544-12.165h-2.733c-.565 0-1.131.374-1.32.935l-4.71 11.23h3.298l.658-1.778h4.053l.377 1.777zM42.3 16.55l.941 4.584h-2.638z",
    clipRule: "evenodd"
  })));
};
export default SvgCardLogoVisa;